import { AppButton } from 'components/form';
import AppLightTooltip from './AppLightTooltip';
import AppSpacer from './AppSpacer';
import AppUseIcon from './AppUseIcon';
import { useTranslation } from 'react-i18next';

const AppPageHeader = ({
  title,
  tooltipContent = '',
  children,
  backBtn = { isVisible: false, onClick: () => {} },
}: {
  title: string;
  tooltipContent?: string;
  children?: React.ReactNode;
  backBtn?: { isVisible: boolean; onClick: () => void };
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className='position-relative w-100 d-flex justify-content-center'>
        <div className='col-4 d-flex'>
          {backBtn.isVisible && (
            <AppButton
              variant='transparent'
              className=' font-13 font-500 text-uppercase font-oswald d-flex align-items-center px-0'
              data-test='back-button'
              onClick={backBtn.onClick}
            >
              <AppUseIcon className='mr-3' name='ChevronLeft' width='10' height='16' />
              {t('back')}
            </AppButton>
          )}
        </div>
        <div className='col-4'>
          <h1 className='text-center mb-0 font-25 text-uppercase'>
            {title}
            {tooltipContent ? (
              <AppLightTooltip title={tooltipContent}>
                <AppUseIcon name='InfoIcon' className='ml-2' />
              </AppLightTooltip>
            ) : null}
          </h1>
        </div>

        <div className='col-4'>{children}</div>
      </div>
      <AppSpacer space='34px' />
    </>
  );
};

export default AppPageHeader;
